const { REACT_APP_RESET_PASSWORD_CLIENT_URL } = process.env

class ForgotPassword {
  constructor(data = {}) {
    this.email = data.email || ''
    this.resetClientURL = REACT_APP_RESET_PASSWORD_CLIENT_URL
  }
}

export default ForgotPassword